import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import organizationChart from "../../../../assets/images/New NMDFC Final Hierarchy chart.svg";

const ChartCard = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
`;

const ChartCanvas = styled.figure`
  position: relative;
  width: 100%;
  min-width: 1050px;
  margin: 0;
`;

const ChartImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const LogoLinkStyles = `
  position: absolute;
  top: 0;
  z-index: 1;
  height: 10.5%;
  border-radius: 8px;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid #ff9933;
    outline-offset: -3px;
  }
`;

const NmdfcLogoLink = styled(Link)`
  ${LogoLinkStyles}
  left: 0;
  width: 14%;
`;

const MinistryLogoLink = styled.a`
  ${LogoLinkStyles}
  right: 0;
  width: 14%;
`;

const OrganizationChartContent = () => (
  <ChartCard>
    <ChartCanvas>
      <ChartImage
        src={organizationChart}
        alt="NMDFC organizational hierarchy chart"
      />
      <NmdfcLogoLink
        to="/"
        aria-label="Go to the NMDFC landing page"
        title="NMDFC home"
      />
      <MinistryLogoLink
        href="https://www.minorityaffairs.gov.in/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit the Ministry of Minority Affairs website"
        title="Ministry of Minority Affairs"
      />
    </ChartCanvas>
  </ChartCard>
);

export default OrganizationChartContent;
